import React from 'react';
import { useAddingCustomTokenContext } from '../../context/adding-custom-token.js';
import useToAsset from '../../hooks/use-to-asset.js';
const AssetLabel = ({ Component, className, style }) => {
    const [addingCustomToken] = useAddingCustomTokenContext();
    const [toAsset] = useToAsset();
    if (Component) {
        return (React.createElement(Component, { side: "to", asset: toAsset, loadingCustomToken: Boolean(addingCustomToken), className: className, style: style }));
    }
    return null;
};
export default AssetLabel;
